import React, { forwardRef } from "react";
import styled from "styled-components";
import { Colors } from "../../../config/Constants";
import { Error } from "../../../config/StyledComponents";
const datepickerImage = require("../../../assets/images/datepicker-icon.png");

const DatePickerField = ({
  value,
  onClick,
  onChange,
  disabled,
  width,
  placeholderText,
  ref,
  helperText,
  label,
  borderRadius = "2.5rem",
  placeHolderColor,
}) => {
  return (
    <div>
      <StyledInput
        type="text"
        value={value}
        className="custom-input"
        ref={ref}
        onChange={(e) => onChange(e.target.value)}
        onClick={onClick}
        disabled={disabled}
        placeholder={placeholderText || `Select ${label}`}
        width={width}
        helperText={helperText}
        borderRadius={borderRadius}
        placeHolderColor={placeHolderColor}
      />
      {helperText && <Error isRounded={true}>{helperText}</Error>}
    </div>
  );
};

const StyledInput = styled.input`
  display: block;
  background: ${(props) =>
    props.disabled ? "" : `url(${datepickerImage}) no-repeat right`};
  background-color: white;
  background-position: calc(100% - 1rem);
  background-position-y: calc(50%);
  cursor: ${(props) => (props.disabled ? "no-drop" : "pointer")};
  border: ${(props) =>
    props.helperText
      ? `1px solid ${Colors.red}`
      : `1px solid ${Colors.coolGrey}`};
  border-radius: ${(props) => props.borderRadius};
  width: 100%;
  padding: 0.9rem 0rem;
  font-size: 0.9rem;
  font-weight: 400;
  text-indent: 1rem;
  color: ${(props) => (props.disabled ? Colors.sharkOpacity10 : Colors.shark)};
  ::placeholder {
    color: ${(props) =>
      props.disabled
        ? Colors.sharkOpacity10
        : props.placeHolderColor
        ? Colors.black
        : Colors.sharkOpacity60};
  }
  :disabled {
    background-color: ${Colors.white};
    font-weight: 700;
  }
`;

export default forwardRef(DatePickerField);
